import {
  Button,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { FormProvider } from 'react-hook-form';

import { TitlesWrapper } from './styled';
import { useFaqLogic } from './useFaqLogic';

const FaqMutation = () => {
  const {
    paramId,
    isLoading,
    methods,
    errors,
    isSuccess,
    isButtonLoading,
    onSubmit,
    register,
    handleSubmit,
  } = useFaqLogic();

  if (isLoading) {
    return <div>Loading</div>
  }

  return (
    <FormProvider {...methods}>
      <Stack
        onSubmit={handleSubmit(onSubmit)}
        component="form"
      >
        <Typography
          variant="h5"
          sx={{ mb: 4 }}
        >
          { paramId ? 'Edit Faq' : 'Create New Faq'}
        </Typography>

        <TitlesWrapper>
          <TextField
            {...register('questionAm')}
            label="Question Am"
            error={!!errors.questionAm}
            helperText={errors.questionAm ? 'Question is required' : ''}
          />
          <TextField
            {...register('questionEn')}
            label="Question En"
            error={!!errors.questionEn}
            helperText={errors.questionEn ? 'Question is required' : ''}
          />
          <TextField
            {...register('questionRu')}
            label="Question Ru"
            error={!!errors.questionRu}
            helperText={errors.questionRu ? 'Question is required' : ''}
          />
          <TextField
            {...register('answerAm')}
            label="Answer Am"
            error={!!errors.answerAm}
            helperText={errors.answerAm ? 'Answer is required' : ''}
          />
          <TextField
            {...register('answerEn')}
            label="Answer En"
            error={!!errors.answerEn}
            helperText={errors.answerEn ? 'Answer is required' : ''}
          />

          <TextField
            {...register('answerRu')}
            label="Answer Ru"
            error={!!errors.answerRu}
            helperText={errors.answerRu ? 'Answer is required' : ''}
          />
        </TitlesWrapper>

        <p>{isSuccess}</p>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          sx={{ mt: 1 }}
          disabled={isButtonLoading}
        >
          {paramId ? 'UPDATE' : "CREATE"}
        </Button>
      </Stack>
    </FormProvider>
  );
};

export default FaqMutation;
